import { Url } from "./Url.service";
import { HandleResponse, AuthHeader } from "../_helpers";

export const ReporteriaService = {
    ObtenerSolicitudesEmpresas,
    DescargarExcelEmpresas
};

function ObtenerSolicitudesEmpresas(data) {
    return fetch(
        `${Url}Reporteria/Obtener_Solicitudes_Empresa`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...AuthHeader()
            },
            body: JSON.stringify(data)
        }
    ).then(HandleResponse);
}

function DescargarExcelEmpresas(data) {
    return fetch(
        `${Url}Reporteria/Reporte_Solicitudes_Empresa`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...AuthHeader()
            },
            body: JSON.stringify(data) 
        }
    )
    .then(response => {
        if (!response.ok) {
            return Promise.reject(response.statusText);
        }
        return response.blob(); 
    })
    .then(blob => {
        const url = window.URL.createObjectURL(
            new Blob([blob], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        );
        
        const link = document.createElement('a');
        link.href = url;
        
        link.setAttribute('download', `Reporteria_Solicitudes_${new Date().getTime()}.xlsx`);
        
        document.body.appendChild(link);
        link.click();
        
        link.parentNode.removeChild(link);
    });
}